import styled from 'styled-components';

export const BranchInfo = styled.div<{ branchPrimaryColor?: string }>`
  width: 100%;
  height: 120px;
  padding-left: 17px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-color: ${({ branchPrimaryColor }) => branchPrimaryColor};
  justify-content: space-between;
  padding: 0px 20px;
  display: flex;
  align-items: center;

  @media (max-width: 1200px) {
    border-radius: 0;
  }
`;

export const ProviderInfo = styled(BranchInfo)`
  position: absolute;
  border-radius: 0;
  z-index: 1;
  background-color: transparent;
  top: 0;
  left: 0;
  z-index: 0;

  @media (max-width: 1200px) {
    z-index: 1;
    backdrop-filter: blur(20px);
  }
`;

export const BranchLogo = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  user-select: none;

  @media (max-width: 1200px) {
    width: 80px;
    height: 80px;
  }
`;
